const initialState = {
    activitiesDetail: {
        newActivity: false,
        actId: '',
        dateCompleted: '',
        dateEarly: '',
        dateLate: '',
        activityType: {
            id: '',
            value: ''
        },
        activityByWestCareEmployee: {
            id: '',
            value: ''
        },
        activityWithContactName: {
            id: '',
            value: ''
        },
        activityWithContactType: {
            id: '',
            value: ''
        },
        unitQty: '',
        priority: '',
        Is12StepQuestionAsked: false,
        Is12StepQuestionAnswered: false,
        recdCBPROI: false,
    }
}

export default initialState